import { computed, type ComputedRef, watchEffect } from 'vue';
import { useI18n } from '@experience/i18n';
import ru from '@/entities/tour-activities/i18n/ru.json';
import { ToursActivitiesCategory } from '@/entities/tour-activities/types';

export type ToursActivitiesLabelsHook = {
  labels: ComputedRef<Record<ToursActivitiesCategory, string>>;
  labelOf: (c: ToursActivitiesCategory) => string;
};

export function useToursActivitiesLabels(): ToursActivitiesLabelsHook {
  const { t, locale, mergeLocaleMessage } = useI18n({ inheritLocale: true });

  watchEffect(() => {
    mergeLocaleMessage(locale.value as string, ru);
  });

  const labels = computed<Record<ToursActivitiesCategory, string>>(() => ({
    [ToursActivitiesCategory.ACTIVE]: t('active'),
    [ToursActivitiesCategory.EDUCATIONAL]: t('educational'),
    [ToursActivitiesCategory.CALM]: t('calm'),
    [ToursActivitiesCategory.NATURE]: t('nature'),
  }));

  const labelOf = (c: ToursActivitiesCategory) => labels.value[c] ?? '';

  return { labels, labelOf };
}
